import { Field, TextInput, Choice, StepTitle, inputCls } from "@/components/register/Fields";

const SIZES = ["XS", "S", "M", "L", "XL"].map((s) => ({ value: s, label: s }));
const POSITIONS = ["Goalkeeper", "Defender", "Midfielder", "Forward", "Not sure yet"];

export const StepPlayer = ({ player, set, errors, group, index }) => (
  <div data-testid="step-player">
    <StepTitle eyebrow={`Player ${index + 1} · Step 2`} title="Player details" sub="Groups are allocated by birth year and gender." />
    <div className="grid sm:grid-cols-2 gap-5">
      <Field label="First name" error={errors.first_name}>
        <TextInput testid="player-first-name" value={player.first_name} onChange={(e) => set("first_name", e.target.value)} />
      </Field>
      <Field label="Last name" error={errors.last_name}>
        <TextInput testid="player-last-name" value={player.last_name} onChange={(e) => set("last_name", e.target.value)} />
      </Field>
      <Field label="Date of birth" error={errors.date_of_birth}>
        <TextInput testid="player-dob" type="date" min="2005-01-01" max="2020-12-31" value={player.date_of_birth} onChange={(e) => set("date_of_birth", e.target.value)} />
      </Field>
      <Field label="Gender" error={errors.gender}>
        <Choice testid="player-gender" value={player.gender} onChange={(v) => set("gender", v)} options={[{ value: "male", label: "Boy" }, { value: "female", label: "Girl" }]} />
      </Field>
      <Field label="Preferred position">
        <select data-testid="player-position" className={inputCls} value={player.position} onChange={(e) => set("position", e.target.value)}>
          <option value="">Select…</option>
          {POSITIONS.map((p) => <option key={p} value={p}>{p}</option>)}
        </select>
      </Field>
      <Field label="T-shirt size" error={errors.tshirt_size}>
        <Choice testid="player-size" value={player.tshirt_size} onChange={(v) => set("tshirt_size", v)} options={SIZES} />
      </Field>
    </div>
    {player.date_of_birth && player.gender && (
      <div data-testid="player-group-result" className={`mt-8 rounded-2xl border p-5 ${group ? "border-[var(--accent)]/30 bg-[var(--accent)]/[0.05]" : "border-red-400/30 bg-red-400/[0.05]"}`}>
        {group ? (
          <p className="text-sm text-slate-300">Allocated group: <span data-testid="player-group-name" className="font-display font-bold text-lg accent-text ml-1">{group.name}</span></p>
        ) : (
          <p data-testid="player-ineligible" className="text-sm text-red-300">This player isn't eligible. The programme is for boys and girls born 2011–2016 within the published group ranges.</p>
        )}
      </div>
    )}
  </div>
);
